module.exports = __webpack_public_path__ + "img/erroricon.7cc6d566.png";